import { Container } from 'inversify'

import { AmericanFootballIncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindIncidentsResultConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.IncidentsResultConfiguration)
    .toDynamicValue(() => {
      return {
        scoringIncidents: new Map([
          [AmericanFootballIncidentId.Touchdown, { add: 6, visible: true }],
          [AmericanFootballIncidentId.FieldGoal, { add: 3, visible: true }],
          [AmericanFootballIncidentId.Safety, { add: 2, visible: true }],
          [
            AmericanFootballIncidentId.TwoPointConversion,
            { add: 2, visible: true },
          ],
          [AmericanFootballIncidentId.ExtraPoint, { add: 1, visible: true }],
        ]),
      }
    })
    .inSingletonScope()
}
